import React from "react";
import Media from "react-media";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import { TermsAndConditionState } from "../../states/TermsAndConditionState";
import './TermsAndCondition.css';
import { Document, Page } from 'react-pdf';
// @ts-ignore
import * as pdfDocuments from "../../resources/documents/TC_MobilePOS.pdf";
import _ from 'lodash';
import { Button } from "@material-ui/core";
import ChevronDownIcon from "../../resources/wrappers/ChevronDownIcon";
import { TermsAndConditionsManager } from "../../services/termsAndConditions/TermsAndConditionsManager";
import { Route } from "react-router-dom";
import { Subscription } from "rxjs";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";

export class TermsAndCondition extends React.Component<any, TermsAndConditionState> {
    counter: number = 0;
    private updateTCSubscription: Subscription | null = null;
    constructor(props: any){
        super(props);

        this.state = {
            pageNumber: 1,
            totalNumberOfPages: null,
            widthPageForMobile: (window.innerWidth - 30),
            readCompletion: false,
            loadingSuccess: false,
            buttonDocumentFixed: true
        }

        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    }

    private renderDesktopHeader(): JSX.Element {
        return (
            <HeaderDesktop showBack={this.props.location.state.fromHome ? true : false} showLogout={false} showTitle={true} title={"TERMINI E CONDIZIONI"}/>);
    }
    private renderMobileHeader(): JSX.Element {
        return (
            <HeaderMobile showBack={this.props.location.state.fromHome ? true : false} showLogout={false} showTitle={true} title={"TERMINI E CONDIZIONI"}/>);
    }

    componentDidMount(){
        window.addEventListener('resize', () => {
            this.setState({widthPageForMobile: (window.innerWidth - 30)});
        });

        const self = this;
        let onScroll = () => {
            const wrappedElement = document.getElementsByClassName('tc-pdf-document')[0];
            if(wrappedElement !== undefined){
                if(wrappedElement.getBoundingClientRect().bottom <= window.innerHeight) {
                    console.log('Document bottom reached');
                    self.setState({readCompletion: true});
                    self.setState({buttonDocumentFixed: false});
                } else {
                    self.setState({buttonDocumentFixed: true});
                }
            }
        }
        document.addEventListener('scroll', onScroll);

        this.counter = 0;

        if(this.props.location.state.fromHome){
            GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Termini e condizioni', {});
        } else {
            GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Accetta termini e condizioni', {});
        }
    }

    componentWillUnmount(){
        window.removeEventListener('resize', () => {
            this.setState({widthPageForMobile: (window.innerWidth - 30)});
        });

        const self = this;
        let onScroll = () => {
            const wrappedElement = document.getElementsByClassName('tc-pdf-document')[0];
            if(wrappedElement !== undefined){
                if(wrappedElement.getBoundingClientRect().bottom <= window.innerHeight) {
                    console.log('Document bottom reached');
                    self.setState({readCompletion: true});
                    self.setState({buttonDocumentFixed: false});
                } else {
                    self.setState({buttonDocumentFixed: true});
                }
            }
        }
        document.removeEventListener('scroll', onScroll);

        if(this.updateTCSubscription !== null){
            this.updateTCSubscription.unsubscribe();
        }
    }

    // @ts-ignore
    onDocumentLoadSuccess({numPages}) {
        this.setState({totalNumberOfPages: numPages});
    }

    onPageLoadSuccess(){
        console.log("[TermsAndCondition] onPageLoadSuccess");
        this.counter++;
        if(this.counter === this.state.totalNumberOfPages){
            console.log("[TermsAndCondition] onPageLoadSuccess: all pages loaded!");
            this.setState({loadingSuccess: true});
            this.counter = 0;
        }
    }

    renderDesktopPageFromHome(): JSX.Element[] {
        let pagesElements: JSX.Element[] = [];
        let i;
        if(this.state.totalNumberOfPages !== null){
            for(i = 1; i <= this.state.totalNumberOfPages; i++){
                pagesElements.push(<Page key={i} pageNumber={i} width={910} loading={""}/>)
            }
        }

        return pagesElements;
    }

    renderMobilePageFromHome(): JSX.Element[] {
        let pagesElements: JSX.Element[] = [];
        let i;
        if(this.state.totalNumberOfPages !== null){
            for(i = 1; i <= this.state.totalNumberOfPages; i++){
                pagesElements.push(<Page key={i} pageNumber={i} loading={""} width={this.state.widthPageForMobile}/>)
            }
        }

        return pagesElements;
    }

    renderDesktopPageAfterChangePassword(): JSX.Element[] {
        let pagesElements: JSX.Element[] = [];
        let i;
        if(this.state.totalNumberOfPages !== null){
            for(i = 1; i <= this.state.totalNumberOfPages; i++){
                pagesElements.push(<Page key={i} pageNumber={i} width={910} loading={""} onLoadSuccess={() => {this.onPageLoadSuccess()}}/>)
            }
        }

        return pagesElements;
    }

    renderMobilePageAfterChangePassword(): JSX.Element[] {
        let pagesElements: JSX.Element[] = [];
        let i;
        if(this.state.totalNumberOfPages !== null){
            for(i = 1; i <= this.state.totalNumberOfPages; i++){
                pagesElements.push(<Page key={i} pageNumber={i} loading={""} width={this.state.widthPageForMobile} onLoadSuccess={() => {this.onPageLoadSuccess()}}/>)
            }
        }

        return pagesElements;
    }

    goToDocumentEnd(){
        const wrappedElement = document.getElementsByClassName('tc-pdf-document')[0];
        window.scrollTo(0, wrappedElement.getBoundingClientRect().bottom);
    }

    acceptTermsAndConditions(history: any){
        console.log("[TermsAndCondition] Accept called!");
        this.updateTCSubscription = TermsAndConditionsManager.getInstance().updateTCStatus().subscribe((result) => {
            console.log("[TermsAndCondition] RESULT: " + result);
            history.push('/');
        }, () => {
            history.push('/');
        });
    }

    render(){
        // @ts-ignore
        return <div id={"main-container-tc"}>
            {
                this.props.location.state.fromHome && [<Media query="(max-width: 1064px)" render={() => this.renderMobileHeader() }/>,
                <Media query="(min-width: 1065px)" render={() => this.renderDesktopHeader() }/>]
            }
            {
                [this.props.location.state.fromHome && <div className={"tc-container-content"}>
                    <Document file={pdfDocuments} onLoadSuccess={this.onDocumentLoadSuccess} loading={""} renderMode="svg" className={"tc-pdf-document"}>
                        <Media query="(min-width: 1065px)" render={() => {
                            return _.map(this.renderDesktopPageFromHome(), (element) => {
                                return element;
                            })
                        }}/>
                        <Media query="(max-width: 1064px)" render={() => {
                            return _.map(this.renderMobilePageFromHome(), (element) => {
                                return element;
                            })
                        }}/>
                    </Document>
                </div>, 
                (!this.props.location.state.fromHome && <div className={"tc-container-content tc-container-margin"}>
                    <p className={"tc-page-title"}>Termini e condizioni</p>
                    <p className={"tc-page-subtitle"}>Dedica un momento per leggere e accettare le nostre condizioni e la normativa sui dati.</p>
                    <Document file={pdfDocuments} onLoadSuccess={this.onDocumentLoadSuccess} loading={""} renderMode="svg" className={"tc-pdf-document"}>
                        <Media query="(min-width: 1065px)" render={() => {
                            return _.map(this.renderDesktopPageAfterChangePassword(), (element) => {
                                return element;
                            })
                        }}/>
                        <Media query="(max-width: 1064px)" render={() => {
                            return _.map(this.renderMobilePageAfterChangePassword(), (element) => {
                                return element;
                            })
                        }}/>
                    </Document>
                </div>)]
            }
            {
                (!this.props.location.state.fromHome && this.state.loadingSuccess) && (<Route render={({history}) => {
                        return <Button 
                            id={"tc-button-accept"} 
                            className={this.state.buttonDocumentFixed ? "tc-button-read-not-completed" : ""}
                            onClick={() => {
                            this.state.readCompletion ? this.acceptTermsAndConditions(history) : this.goToDocumentEnd();
                        }}>
                            {this.state.readCompletion ? "ACCETTA LE CONDIZIONI" : <div className={"tc-button-icon"}>
                                <ChevronDownIcon width={"30px"} height={"30px"} fill={"#FFFFFF"}/>
                            </div>}
                        </Button>
                }}/>)
            }
        </div>
    }
}